import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import AppImage from '../../../components/AppImage';


const RegistrationHeader = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login-screen');
  };

  return (
    <div className="text-center space-y-6">
      {/* Logo */}
      <div className="flex justify-center">
        <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center shadow-tier-2 cursor-pointer transition-transform duration-300 origin-top z-50 hover:scale-[4] hover:translate-y-10 md:hover:scale-[8] md:hover:translate-y-12">
            <AppImage
              src="/assets/images/major-high-logo.png"
              alt="Major High Logo"
              className="w-16 h-16 object-contain"
            />
          </div>
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-3xl font-heading font-bold text-foreground">
          Crie sua conta
        </h1>
        <p className="text-lg text-muted-foreground font-caption">
          Junte-se à Academy Platform e comece sua jornada de aprendizado
        </p>
      </div>

      {/* Back to Login */}
      <div className="flex items-center justify-center space-x-2">
        <span className="text-sm text-muted-foreground font-caption">
          Já tem uma conta?
        </span>
        <Button
          variant="link"
          onClick={handleBackToLogin}
          iconName="ArrowLeft"
          iconPosition="left"
          iconSize={16}
          className="p-0 h-auto text-white hover:text-primary/80"
        >
          Fazer login
        </Button>
      </div>
    </div>
  );
};

export default RegistrationHeader;